import { render, staticRenderFns } from "./BaseReportLink.vue?vue&type=template&id=36273d64&scoped=true"
import script from "./BaseReportLink.vue?vue&type=script&lang=js"
export * from "./BaseReportLink.vue?vue&type=script&lang=js"
import style0 from "./BaseReportLink.vue?vue&type=style&index=0&id=36273d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36273d64",
  null
  
)

export default component.exports